import type { SVGProps } from 'react';

const SvgDehaze = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="currentColor"
    {...props}
  >
    <path d="M2 16v2h20v-2zm0-5v2h20v-2zm0-5v2h20V6z" />
  </svg>
);
export default SvgDehaze;
